export const RadioLabelSize = {
  NORMAL: 'normal',
  SMALL: 'small'
};